
import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { WeBuyHero } from './components/WeBuyHero';
import { WeBuyBenefits } from './components/WeBuyBenefits';
import { WeBuyProcess } from './components/WeBuyProcess';
import { WeBuyPropertyTypes } from './components/WeBuyPropertyTypes';
import { WeBuyTestimonials } from './components/WeBuyTestimonials';
import { WeBuyFAQ } from './components/WeBuyFAQ';
import { ContactCTA } from './components/ContactCTA';
import { WhyChooseUs } from './components/WhyChooseUs';
import { OurApproach } from './components/OurApproach';
import { MarketExpertise } from './components/MarketExpertise';
import { FinancingOptions } from './components/FinancingOptions';
import { PropertyConditions } from './components/PropertyConditions';
import { TimelineComparison } from './components/TimelineComparison';
import { SellerStories } from './components/SellerStories';

const WeBuyApartmentBuildings: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <WeBuyHero />
      <WeBuyBenefits />
      <WhyChooseUs />
      <OurApproach />
      <MarketExpertise />
      <WeBuyProcess />
      <FinancingOptions />
      <PropertyConditions />
      <TimelineComparison />
      <WeBuyPropertyTypes />
      <SellerStories />
      <WeBuyTestimonials />
      <WeBuyFAQ />
      <ContactCTA />
      <Footer />
    </div>
  );
};

export default WeBuyApartmentBuildings;
